import { render, staticRenderFns } from "./HeaderAdminSettings.vue?vue&type=template&id=13d07afa"
import script from "./HeaderAdminSettings.vue?vue&type=script&lang=js"
export * from "./HeaderAdminSettings.vue?vue&type=script&lang=js"
import style0 from "./HeaderAdminSettings.vue?vue&type=style&index=0&id=13d07afa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports